import { RETENTION_API } from "../../vars";
import { showDangerToast, showSuccessToast } from "../../validation/ToastContainer";
import { securedFetch } from "../../auth/authService";


export async function getDBSelectedDaysPeriod() {
    let text = "";
    return securedFetch(`${RETENTION_API}/dbretention/selectedDays`, {
        method: 'GET',
        headers: {
            'Content-Type': 'text/plain'
        }

    }).then(async response => {
        if (!response.ok) {
            const json = await response.json();
            showDangerToast(`${json.message || 'DB Retention Period does not exist'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
        } else {
            text = await response.text();
        }
        return text
    })

}

//Added by Octopus DevTeam Jun 2 2022
export async function getLogsSelectedDaysPeriod() {
    let text = "";
    return securedFetch(`${RETENTION_API}/logsretention/selectedDays`, {
        method: 'GET',
        headers: {
            'Content-Type': 'text/plain'
        }

    }).then(async response => {
        if (!response.ok) {
            const json = await response.json();
            showDangerToast(`${json.message || 'DB Retention Period does not exist'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
        } else {
            text = await response.text();
        }
        return text
    })

}

export async function modifyScheduler(days) {
    //let newDate=ISODateString(date);

    return securedFetch(`${RETENTION_API}/dbretention`, {
        days: days
    })
        .then(async response => {
            if (!response.ok) {
                const json = await response.json();
                showDangerToast(`${json.message || 'Setting DB Retention Period was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
            } else {
                showSuccessToast('Setting DB Retention Period is successful', 'DB Retention Period')
            }

            return response.ok;
        })
}

//Added by Octopus DevTeam Jun 2 2022
export async function modifyLogsScheduler(days) {
    //const d =(date.getFullYear())+"-"+(date.getMonth() + 1) +"-"+date.getDate();

    return securedFetch(`${RETENTION_API}/logsretention`, {
        days: days
    })
        .then(async response => {
            if (!response.ok) {
                const json = await response.json();

                showDangerToast(`${json.message || 'Setting Logs Retention Period was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
            } else {
                showSuccessToast('Setting Logs Retention Period is successful', 'Logs Retention Period')
            }

            return response.ok;
        })
}
/* export function ISODateString(d){
    function pad(n){return n<10 ? '0'+n : n}
     return d.getUTCFullYear()+'-'
         + pad(d.getUTCMonth()+1)+'-'
         + pad(d.getUTCDate())+'T'
         + pad(d.getUTCHours())+':'
         + pad(d.getUTCMinutes())+':'
         + pad(d.getUTCSeconds())+'Z'
        
    }  */
